export default "__VITE_ASSET__CytSt78g__"